import SidebarClient from "../../component/sideBarClient/SideBarClient";
import Axios from "axios";
import { useState, useEffect } from "react";
import DocReview from "../../component/docReview/docReview";
import FormCard from "../../component/formCard/FormCard";
import { useParams } from "react-router-dom";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";


export default function ClientUploadDoc() {

    const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS;
    const [data, setData] = useState();
    const [numberDoc, setNumberDoc] = useState('');
    const { id } = useParams();

    useEffect(() => {
        Axios({
            method: "GET",
            withCredentials: true,
            url: `${backEndUrl}/auth`,
        }).then((res) => {
            setData(res.data);
        });
    }, []);

    useEffect(() => {
        if (data) {
            const notUploaded = data.documents.filter(d => d.status === "not uploaded");
            setNumberDoc(notUploaded.length);
        }
    }, [data]);

    function displayDocuments(doc) {
        return (
            <DocReview
                key={doc._id}
                name={doc.name}
                rid={doc._id}
                description={doc.description}
                path={doc.doc_upload}
                consultantAttachment={doc.doc_upload_consultantSide}
                userID={id}
                status={doc.status}
                review={doc.review}
                reason={doc.reason}
                clientName={data.firstName}
                storageUsed={data.consultantStorage}
                language={data.language}
                isDemo={data.isDemo || false}
            />
        );
    }

    if (data === undefined) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#F8FAFC]">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-8 h-8 border-2 border-slate-200 border-t-sky-500 rounded-full animate-spin" />
                    <p className="text-sm text-slate-400">Loading…</p>
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#F8FAFC]">
                <p className="text-slate-500">Not authorized.</p>
            </div>
        );
    }

    const isFrench = data.language === 'french';
    const totalDocs = data.documents.length;
    const uploadedDocs = data.documents.filter(d => d.status === 'uploaded' || d.status === 'approved').length;
    const progressPct = totalDocs > 0 ? Math.round((uploadedDocs / totalDocs) * 100) : 0;
    return (
        <div className="home">
            <SidebarClient companyName={data.companyName} />

            <div className="homeContainer">
                <div className="min-h-screen bg-[#F8FAFC] pb-24 font-sans">

                    <div className="max-w-4xl mx-auto px-6 mt-10">

                        {/* ── Welcome + progress ── */}
                        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
                            <div>
                                <h1 className="text-3xl font-light text-slate-900 mb-2">
                                    {isFrench ? 'Bonjour, ' : 'Welcome back, '}
                                    <span className="font-bold">{data.firstName}</span>
                                </h1>
                                <p className="text-slate-500 text-sm">
                                    {numberDoc === 0
                                        ? (isFrench
                                            ? 'Tous vos documents ont été soumis ✓'
                                            : 'All your documents have been submitted ✓')
                                        : (isFrench
                                            ? <span>Il vous reste <span className="text-sky-600 font-bold">{numberDoc} document{numberDoc > 1 ? 's' : ''}</span> à fournir.</span>
                                            : <span>You have <span className="text-sky-600 font-bold">{numberDoc} document{numberDoc > 1 ? 's' : ''}</span> left to provide.</span>)
                                    }
                                </p>
                            </div>

                            <div className="w-full md:w-72 space-y-2 shrink-0">
                                <div className="flex justify-between items-end">
                                    <span className="text-[10px] font-black uppercase text-slate-400 tracking-widest">
                                        {isFrench ? 'Avancement' : 'Completion Progress'}
                                    </span>
                                    <span className={`text-sm font-bold ${progressPct === 100 ? 'text-emerald-600' : 'text-sky-600'}`}>
                                        {progressPct}%
                                    </span>
                                </div>
                                <div className="h-2 w-full bg-slate-200 rounded-full overflow-hidden">
                                    <div
                                        className={`h-full rounded-full transition-all duration-1000 ease-out ${progressPct === 100 ? 'bg-emerald-500' : 'bg-sky-500'}`}
                                        style={{ width: `${progressPct}%` }}
                                    />
                                </div>
                                <div className="flex justify-between text-[10px] text-slate-400">
                                    <span>{uploadedDocs} {isFrench ? 'soumis' : 'submitted'}</span>
                                    <span>{totalDocs} {isFrench ? 'au total' : 'total'}</span>
                                </div>
                            </div>
                        </div>

                        {/* ── Checklist ── */}
                        <div className="space-y-6">
                            <div className="flex items-center gap-3 px-2">
                                <h2 className="text-xs font-black uppercase text-slate-400 tracking-[0.2em] whitespace-nowrap">
                                    {isFrench ? 'Liste de documents' : 'Required Checklist'}
                                </h2>
                                <div className="h-px flex-1 bg-slate-200" />
                            </div>

                            {data.documents.map(displayDocuments)}
                        </div>

                        {/* ── Forms ── */}
                        {data.formsAssigned && data.formsAssigned.length > 0 && (
                            <div className="space-y-6 mt-12">
                                <div className="flex items-center gap-3 px-2">
                                    <h2 className="text-xs font-black uppercase text-slate-400 tracking-[0.2em] whitespace-nowrap">
                                        {isFrench ? 'Formulaires à remplir' : 'Forms to Complete'}
                                    </h2>
                                    <div className="h-px flex-1 bg-slate-200" />
                                </div>

                                {data.formsAssigned.map((form) => (
                                    <FormCard key={form._id} form={form} language={data.language} />
                                ))}
                            </div>
                        )}

                        {/* ── Security footer ── */}
                        <div className="mt-20 flex justify-center opacity-40">
                            <div className="flex items-center gap-5">
                                <ShieldCheckIcon className="h-8 w-8 text-slate-400 shrink-0" />
                                <div className="border-l border-slate-300 pl-5">
                                    <p className="text-[10px] font-black uppercase tracking-widest text-slate-500">Encryption Active</p>
                                    <p className="text-xs text-slate-400 mt-0.5">All documents are secured with AES-256 bank-grade protection.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
